import {
  ChangeUserAmountFormType,
  UpdatePointAccumulatedType,
  UpdatePointAchieveType,
  UpdatePointCustomReferralType,
  UpdatePointSettingType,
  UpdatePointStakeType,
  UpdatePointUserIdAddressType,
} from '@/types';
import { sendRequest } from '../AxiosRequest';
import { axiosPatch, axiosPost } from '../AxiosApi';

export const updatePointSetting = async (updatePointSettingType: UpdatePointSettingType) => {
  const payload = {
    path: '/point-settings/update',
    body: { ...updatePointSettingType },
  };
  return sendRequest(payload, 'updatePointSetting', axiosPatch);
};

export const updatePointAccumulated = async (updatePointAccumulatedType: UpdatePointAccumulatedType) => {
  const payload = {
    path: '/point-settings/accumulated-update',
    body: { ...updatePointAccumulatedType },
  };
  return sendRequest(payload, 'updatePointAccumulated', axiosPatch);
};

export const UpdateUserTot = async (changeUserAmountFormType: ChangeUserAmountFormType) => {
  const payload = {
    path: '/point-admins/user-tot-update',
    body: { ...changeUserAmountFormType },
  };
  return sendRequest(payload, 'updateUserTot', axiosPost);
};

export const updatePointAchieve = async (updatePointAchieveType: UpdatePointAchieveType) => {
  const payload = {
    path: '/point-settings/achieve-update',
    body: { ...updatePointAchieveType },
  };
  return sendRequest(payload, 'updatePointAchieve', axiosPatch);
};

export const updatePointStake = async (updatePointStakeType: UpdatePointStakeType) => {
  const payload = {
    path: '/point-settings/season-update',
    body: { ...updatePointStakeType },
  };
  return sendRequest(payload, 'updatePointAchieve', axiosPatch);
};

export const updatePointCustomReferral = async (updatePointCustomReferralType: UpdatePointCustomReferralType) => {
  const payload = {
    path: '/point-admins/custom-referral',
    body: { ...updatePointCustomReferralType },
  };
  // patch로 했을 땐 계속 안되서 post로 변경함
  return sendRequest(payload, 'updatePointCustomReferral', axiosPost);
};

export const updatePointIdAddress = async (updatePointUserIdAddressType: UpdatePointUserIdAddressType) => {
  const payload = {
    path: '/point-admins/update-id-address',
    body: { ...updatePointUserIdAddressType },
  };
  // patch로 했을 땐 계속 안되서 post로 변경함
  return sendRequest(payload, 'updatePointIdAddress', axiosPatch);
};
